import SCORM from "../scorm/ScormWrapper";
import _ from "lodash";
import state from "../../state";
import PlayerPaths from "../../constants/paths/playerPaths";

export default class PersistenceManagerScorm1_2 {

	constructor(config) {
		this.config = config;
		this.interactionCount = 0;
		this.interactionIds = {};
		this.initialResponses = {};
		this.initialSuspendData = {};
	}

	//get all responses and set interaction count
	async init() {
		SCORM.init();

		this.interactionCount = SCORM.get("cmi.interactions._count");

		for (let i = 0; i < this.interactionCount; i++) {

			let id = SCORM.get("cmi.interactions." + i + ".id");
			let response = SCORM.get("cmi.interactions." + i + ".student_response");

			if (!this.initialResponses[id]) {
				this.interactionIds[id] = this.initialResponses[id] = {};
			}

			this.initialResponses[id] = {
				id,
				response,
			}

			//track interaction IDs for lookup later
			this.interactionIds[id] = {
				id,
				index: i
			}

			this.initialSuspendData = JSON.parse(SCORM.get("cmi.suspend_data"));
		}
	}

	async save() {
		SCORM.save();
	}

	async saveResponse(item) {

		let activity = state.get(PlayerPaths.ACTIVITY);
		let id = item.guid;

		//for now set value based on data type
		let response = this.getResponseFromItem(item);

		let idx = this.findInteractionIndex(id);

		SCORM.set("cmi.interactions." + idx + ".id", "activity_" + activity.instanceId + "_item_" + id);
		SCORM.set("cmi.interactions." + idx + ".type", response.type);
		SCORM.set("cmi.interactions." + idx + ".student_response", response.value);
	}

	restoreActivityResponsesAndState(activity) {

		//restore activity values from initial lms load
		if (activity.children) {

			for (let i = 0; i < activity.children.length; i++) {

				let list = activity.children[i];
				if (list.type === "list" && list.children) {

					let listState = this.initialSuspendData[list.guid];

					if (!_.isUndefined(listState)) {
						list.completionState = (listState.completionState) ? listState.completionState : list.completionState;
					}

					for (let j = 0; j < list.children.length; j++) {

						let section = list.children[j];
						if (section.type === "section" && section.children) {

							let sectionState = this.initialSuspendData[section.guid];

							if (!_.isUndefined(sectionState)) {
								section.completionState = (sectionState.completionState) ? sectionState.completionState : section.completionState;
							}

							for (let k = 0; k < section.children.length; k++) {
								let item = section.children[k];
								if (item.type === "item") {

									let itemState = this.initialSuspendData[item.guid];

									if (!_.isUndefined(itemState)) {
										item.completionState = (itemState.completionState) ? itemState.completionState : item.completionState;
										item.checked = (itemState.checked) ? itemState.checked : item.checked;
									}

									this.restoreItemResponse(item);
								}
							}
						}
					}
				}
			}
		}
		return activity;
	}

	restoreItemResponse(item) {

		let type = item.type.toLowerCase();

		if (this.initialResponses[item.id]) {
			switch (type) {
				case "item":
				case "itemtextinput":
				case "itemtextinputmultiline":
				case "itempicker":
				case "itemyesno":
				case "itembarcodescanner":
				case "itemtime":
				case "itemdate":
				case "itemdatetime":
				case "itemchoicesingle":
					item.value = this.initialResponses[item.id].response;
					break;
				case "itemimagepicker": //value, valueUrls
					item.value = this.initialResponses[item.id].response;
					break;
				case "itemaddress": //object
				case "itemlocation": //object
					item.value = JSON.parse(this.initialResponses[item.id].response);
					break;
				case "itemchoicemulti": //array
					item.value = this.initialResponses[item.id].response;
					break;
				default:
					break;
			}
		}
	}

	//return response type and value
	getResponseFromItem(item) {

		let type = item.type.toLowerCase();
		let response;

		//TODO: need to determine what values to store as part of learner response
		switch (type) {
			case "item":
				response = {
					type: "true-false",
					value: (item.checked === true) ? 1 : 0
				}
				break;
			case "itemtextinput":
			case "itemtextinputmultiline":
			case "itempicker":
			case "itemyesno":
			case "itembarcodescanner":
			case "itemtime":
			case "itemdate":
			case "itemdatetime":
			case "itemchoicesingle":
				response = {
					type: "fill-in",
					value: item.value
				}
				break;
			case "itemimagepicker": //value, valueUrls
				response = {
					type: "fill-in",
					value: item.value
				}
				break;
			case "itemaddress": //object
			case "itemlocation": //object
				response = {
					type: "fill-in",
					value: JSON.stringify(item.value)
				}
				break;
			case "itemchoicemulti": //array
				response = {
					type: "choice",
					response: JSON.stringify(item.value)
				};
				break;

			default:
				response = {
					type: "fill-in",
					response: JSON.stringify(item.value)
				}
				break;
		}
		return response;
	}


	findInteractionIndex(id) {
		let idx;
		if (this.interactionIds[id]) {
			idx = this.interactionIds[id].index;
		} else {
			idx = this.getNextInteractionIndex(id);
		}
		return idx;
	}

	getNextInteractionIndex(id) {
		this.interactionCount++;
		this.interactionIds[id] = {
			id,
			index: this.interactionCount
		}
		return this.interactionCount - 1;
	}

	async saveAndExit() {
		SCORM.save();
		SCORM.set('cmi.core.exit', 'suspend');
		SCORM.quit();
	}

	async setCompletionState(completionState) {
		SCORM.set("cmi.completion_status", completionState);
	}

	async trackHistory(historyItem) {
	}
}